import { concatMap, groupBy, mergeMap, take, windowTime } from "rxjs/operators";
export function throttleGroupPerTime(groupingFunction, maxItemsPerWindow, windowMs) {
    return function (source) {
        return source.pipe(groupBy(groupingFunction), mergeMap(function (group) {
            return group.pipe(windowTime(windowMs), concatMap(function (window) { return window.pipe(take(maxItemsPerWindow)); }));
        }));
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/rxjs/custom-operators/throttleGroupPerTime.ts
// module id = 2058
// module chunks = 3